export const DEFAULT_STACK_GROUP = 'stacked'
